import { useQuery } from "@tanstack/react-query";

import { useAuthHeaders } from "../auth/apiClient";

export interface TemplateListItem {
  id: number;
  channel: "email" | "sms" | "telegram";
  code?: string;
  name: string;
  purpose?: string;
  status?: string;
  current_version_id: number;
  updated_at: string;
  updated_by?: string;
}

export function useTemplates() {
  const headers = useAuthHeaders();
  return useQuery({
    queryKey: ["templates"],
    queryFn: async () => {
      const res = await fetch("/api/cockpit/templates", {
        headers,
      });
      if (!res.ok) throw new Error("Templates list failed");
      return res.json() as Promise<{ items: TemplateListItem[] }>;
    },
    staleTime: 60_000,
  });
}
